import React from 'react';

/**
 * Wraps a screen/feature and blocks access if subscription doesn't allow it.
 *
 * @param {string} feature - Feature key to check (e.g. 'browserAutomation', 'ecac', 'dec')
 * @param {string} featureLabel - Human-readable feature name for the paywall message
 * @param {boolean} requireActive - If true, blocks access when subscription is expired (default: true)
 * @param {ReactNode} children - Content to render if allowed
 */
export default function SubscriptionGate({ children }) {
  return <>{children}</>;
}
